import React from 'react';
import portfolioBanner from '../assets/images/banners/portfolio.jpg';
import Portfolio from './Portfolio';

import kceImage from '../assets/images/portfolio/kce.png';
import btraditionalsImage from '../assets/images/portfolio/btraditionals.png';
import mmsImage from '../assets/images/portfolio/mms.png';
import amiImage from '../assets/images/portfolio/ami.png';
import mnImage from '../assets/images/portfolio/mn.png';
import srnImage from '../assets/images/portfolio/srn.png';
import topcareImage from '../assets/images/portfolio/topcare.png';
import excelDrivingImage from '../assets/images/portfolio/excelDriving.png';
import nammaOoruOffersImage
  from '../assets/images/portfolio/nammaOoruoffers.png';
import coconutHillImage from '../assets/images/portfolio/coconutHill.png';
import guganDentalImage from '../assets/images/portfolio/guganDental.png';
import kissikPhotographyImage
  from '../assets/images/portfolio/kissikphotography.png';
const clients = [
  {
    title: 'Kaamadhenu College of Education - India',
    image: kceImage,
    description: {
      Title: 'Kaamadhenu College of Education',
      Description: "Kaamadhenu College of Education is a prominent institution dedicated to providing high-quality teacher training and education. The project focuses on developing a comprehensive online presence for the college to showcase its academic offerings, campus life, faculty expertise, and student achievements. The platform serves as a resource for prospective students, educators, and stakeholders looking to learn more about the college's vision and the impact it has on the future of education.",
      KeyFeatures: [
        'Institution Overview: A detailed introduction to the college, its mission, and core values.',
        'Courses and Programs: Information about various teacher training programs, courses, and certifications offered by the college.',
        "Faculty and Staff: Highlighting the qualifications and experience of the college's experienced faculty members.",
        'Campus Life: Showcasing the vibrant campus environment with photos, student activities, and events.',
        'Student Testimonials: Insights from current students and alumni about their experiences and the value of the education they received.',
        'Events and Workshops: Calendar and information on upcoming educational workshops, seminars, and community outreach programs.',
      ],
      targetAudience: [
        'Aspiring educators looking to pursue a career in teaching and education.',
        'Parents and guardians seeking information about quality education for their children.',
        'Education professionals looking for opportunities to enhance their skills and qualifications.',
        'Alumni and stakeholders interested in staying connected with the college community.',
      ],
    },
    website: 'https://kcesathy.ac.in',
  },
  {
    title: 'SRN School - India',
    image: srnImage,
    description: {
      Title: 'SRN School',
      Description: "SRN School is a progressive educational institution committed to nurturing young minds through a blend of academic excellence, moral values, and holistic development. This project aims to create a dynamic online platform that showcases the school's curriculum, extracurricular activities, facilities, faculty, and community engagement. The website will serve as a digital hub for parents, students, teachers, and visitors to learn about the school's vision and ongoing efforts to shape future leaders.",
      KeyFeatures: [
        'School Overview: A comprehensive introduction to SRN School, its vision, mission, and educational philosophy.',
        'Academics: Details about the academic programs, grade-wise curriculum, and teaching methodologies followed.',
        'Faculty and Administration: Profiles of dedicated teaching staff and school management.',
        'Infrastructure: Visual and written content highlighting modern classrooms, labs, library, and sports facilities.',
        'Student Life: Showcasing co-curricular and extracurricular activities, celebrations, and student achievements.',
        'Parent Corner: Resources, updates, and communication tools for parents to stay informed and involved.',
        'Events and Announcements: Latest news, school events calendar, and important announcements.',
      ],
      targetAudience: [
        'Parents looking for a well-rounded and value-based education for their children.',
        'Students eager to explore academic and extracurricular opportunities.',
        'Teachers and educators seeking to join a nurturing and innovative school environment.',
        'Community members and stakeholders interested in supporting the school’s initiatives and growth.',
      ],
    },
    website: 'https://srnschool.in',
  },
  {
    title: 'Gugan Dental Care - India',
    image: guganDentalImage,
    description: {
      Title: 'Gugan Dental Care - Gobichettipalayam',
      Description: 'Gugan Dental Care is the best dental clinic in Gobichettipalayam (Erode), established by Dr. Sp. Natarajan, B.D.S., on September 4, 2017. Recognized for its excellence in Endodontic Dentistry, the clinic offers comprehensive oral healthcare that looks beyond just teeth—focusing on complete wellness through preventive and personalized dental care. With 9 specialized departments and 23 expert doctors, Gugan Dental Care is committed to creating confident smiles through advanced technology, expert treatment, and compassionate service.',
      KeyFeatures: [
        'Comprehensive Dental Departments: 9 specialized divisions covering all aspects of dental and oral care.',
        'Expert Dental Team: 23 highly qualified dentists led by Dr. Sp. Natarajan, offering specialized treatments.',
        'Preventive Dentistry Focus: Emphasis on early diagnosis, regular check-ups, and long-term oral wellness.',
        'Advanced Dental Technology: State-of-the-art equipment ensuring precise, pain-free, and efficient treatments.',
        'Patient-Centered Experience: Friendly environment, personalized consultations, and transparent treatment plans.',
        'Online Appointment Booking: Hassle-free scheduling for consultations and follow-up visits.',
        'Smile Gallery: Before-and-after treatment showcase demonstrating successful patient outcomes.',
      ],
      targetAudience: [
        'Individuals and families seeking reliable dental care in Gobichettipalayam and nearby regions.',
        'Patients looking for specialized treatments in endodontics, orthodontics, or cosmetic dentistry.',
        'Parents focused on preventive dental care and oral hygiene for their children.',
        'Community members interested in dental awareness programs and oral health education.',
        'Professionals seeking trusted, long-term dental partnerships for regular check-ups and care.',
      ],
    },
    website: 'https://gugandentalcare.com',
  },
  {
    title: 'TOP Care Hospital - India',
    image: topcareImage,
    description: {
      Title: 'TOP Care Hospital - Sathyamangalam',
      Description: 'TOP Care Hospital is a trusted multi-specialty healthcare institution dedicated to delivering quality medical services with compassion, innovation, and excellence. Located in Sathyamangalam, the hospital focuses on advanced treatments, patient safety, and holistic care to ensure healthier communities. This project aims to establish a comprehensive online platform that highlights the hospital’s specialties, facilities, expert doctors, and patient-centric services, making healthcare more accessible and transparent.',
      KeyFeatures: [
        'Virtual Hospital Tour: An interactive showcase of hospital facilities, wards, ICUs, and labs with images and videos.',
        'Specialty Insights: Detailed information on each department such as orthopedics, pediatrics, cardiology, and more.',
        'Doctor Profiles: Easy access to qualifications, expertise, and consultation availability of specialists.',
        'Online Appointments: A seamless booking system for consultations, health check-ups, and follow-ups.',
        'Mobile-Optimized Experience: Smooth browsing for patients and families on smartphones and tablets.',
      ],
      targetAudience: [
        'Patients seeking reliable and affordable healthcare services in Sathyamangalam and surrounding areas.',
        'Families in need of specialized medical care and continuous health support.',
        'Healthcare professionals looking to work in a progressive and patient-focused environment.',
        'Community members, NGOs, and partners interested in healthcare awareness and wellness programs.',
      ],
    },
    website: 'https://topcarehospital.com',
  },

  {
    title: 'Namma Ooru Offers - India',
    image: nammaOoruOffersImage,
    description: {
      Title: 'Namma Ooru Offers – Local Deals, Big Savings!',
      Description: "At Namma Ooru Offers, we bring your favorite local shops and the best deals together in one easy-to-use platform. Whether you're a customer looking for a great bargain or a vendor wanting to reach more people, we've got you covered! We believe in supporting local businesses while helping customers save more on their everyday shopping. Our vendors offer quality products at discounted prices, and our users enjoy awesome offers they won’t find anywhere else.",
      KeyFeatures: [
        'Digital Marketplace: A vibrant online hub showcasing exclusive local offers and shop promotions.',
        'Offer Insights: Highlighted details about discounts, seasonal sales, and limited-time deals from vendors.',
        'Vendor Profiles: Dedicated space for local merchants to showcase their products and business identity.',
        'Online Redemption: Customers can claim, save, or purchase deals instantly through the platform.',
        'Mobile-Optimized Experience: Smooth access to deals and offers across all devices, ensuring convenience for shoppers.',
      ],
      targetAudience: [
        'Local shoppers looking for affordable deals and everyday savings.',
        'Small and medium business owners who want to reach more customers.',
        'Vendors and merchants eager to promote offers without heavy marketing costs.',
        'Community members who value supporting local businesses and strengthening their town’s economy.',
      ],
    },
    website: 'https://nammaooruoffers.com',
  },
  {
    title: 'AMI Engineering - India',
    image: amiImage,
    description: {
      Title: 'AMI Engineering',
      Description: 'At AMI Engineering, we specialize in delivering precision-machined components using state-of-the-art CNC machinery. Our expertise lies in producing high-quality parts that meet rigorous industry standards. With a dedication to innovation and excellence, we craft every component with unparalleled attention to detail, ensuring reliability and superior performance.',
      KeyFeatures: [
        'Advanced CNC Machines: Precision-engineered components with state-of-the-art CNC technology.',
        'ISO 9001:2015 Certified: Guaranteed consistency and reliability through a recognized quality management system.',
        'High Precision: Uncompromising accuracy for intricate and complex designs.',
        'Custom Manufacturing: Tailored solutions to meet diverse client requirements across industries.',
        'Material Versatility: Expertise in working with a wide range of materials, from metals to composites.',
        'Quality Assurance: Rigorous inspections and testing ensure every component meets or exceeds standards.',
        'Innovation-Driven: Continuous improvement and adoption of cutting-edge techniques for superior results.',
      ],
      targetAudience: [
        'Aerospace and Defense: Companies needing precision-machined components for critical applications.',
        'Medical Device Manufacturers: Businesses requiring intricate parts for medical equipment and tools.',
        'Automotive Industry: Manufacturers seeking reliable and precise parts for high-performance vehicles.',
        'Industrial Machinery Providers: Industries needing custom parts for heavy-duty equipment and machinery.',
        'Electronics and Technology: Companies requiring detailed and high-quality components for advanced systems.',
        'Renewable Energy Sector: Firms developing solar, wind, and other sustainable technologies needing durable components.',
      ],
    },
    website: 'https://amiengineering.in',
  },

  {
    title: 'M.N Interior & Exterior - India',
    image: mnImage,
    description: {
      Title: 'M.N Interior & Exterior',
      Description: 'M.N Interior & Exterior specializes in high-quality aluminum fabrication, interior, and exterior design solutions for residential and commercial spaces across Tamil Nadu. The company focuses on creating functional, aesthetic, and durable spaces tailored to client needs.',
      KeyFeatures: [
        'Custom Interior Design: Personalized solutions for residential and commercial spaces.',
        'Exterior Design Expertise: Facade renovations, landscape design, and durable finishes.',
        'Aluminum Fabrication: High-quality doors, windows, partitions, curtain walls, and railings.',
        'Professional Craftsmanship: Skilled team ensuring precision and quality in every project.',
        'Seamless Project Execution: Timely delivery with efficient communication and planning.',
        'Eco-Friendly Options: Sustainable materials and energy-efficient designs.',
        'Client-Centric Approach: Tailored solutions based on client preferences and requirements.',
      ],
      targetAudience: [
        'Homeowners: Individuals looking to enhance their living spaces with custom interiors and exteriors.',
        'Businesses & Offices: Companies seeking modern and functional workspace designs.',
        'Real Estate Developers: Builders requiring premium fabrication and design solutions.',
        'Retail & Hospitality: Restaurants, cafes, and commercial establishments needing aesthetic upgrades.',
        'Architects & Designers: Professionals collaborating on aluminum fabrication and design projects.',
      ],
    },
    website: 'https://mninteriorandexterior.com',
  },

  {
    title: 'B Traditionals - USA',
    image: btraditionalsImage,
    description: {
      Title: 'B Traditionals',
      Description: "This project involves the creation of a user-friendly online store tailored for selling traditional men's and juniors' wear across the USA. The target audience includes men and boys seeking high-quality traditional attire for weddings, festivals, and cultural events, as well as parents shopping for juniors.",
      KeyFeatures: [
        'Responsive Design: Seamless shopping experience across desktops, tablets, and mobile devices.',
        "Product Categories: Easy navigation with filters for men's wear, juniors' wear, accessories, and occasion-based outfits.",
        'Secure Payment Integration: Multiple payment options, including credit cards and digital wallets.',
        'Wishlist and Cart: Save favorite items and manage purchases effortlessly.',
        'Customer Support: Live chat and FAQs for quick assistance.',
        'Fast Shipping: Nationwide delivery with tracking options.',
        'SEO-Optimized Content: Enhanced discoverability for relevant traditional clothing keywords.',
      ],
      targetAudience: [
        'Families: Parents buying traditional wear for children for weddings, festivals, and religious events.',
        'Young Adults & Professionals: Men seeking stylish yet traditional attire for formal occasions.',
        'Online Shoppers: Customers who prefer shopping for traditional wear online.',
        'NRI (Non-Resident Indians): People living abroad wanting to stay connected to their roots through traditional clothing.',
      ],
    },
    website: 'https://btraditionals.com',
  },
  {
    title: 'Madurai Meenakshi Sculptures - USA',
    image: mmsImage,
    description: {
      Title: 'Madurai Meenakshi Sculptures',
      Description: 'Madurai Meenakshi Sculptures is a tribute to the rich cultural heritage of Tamil Nadu, specifically showcasing the intricate craftsmanship of traditional Indian artisans. The project is centered around creating a digital platform that highlights sculptures inspired by the iconic Madurai Meenakshi Temple, renowned for its architectural grandeur and artistic legacy. This platform caters to art enthusiasts, collectors, and tourists, offering them a virtual gallery to explore and appreciate these timeless creations.',
      KeyFeatures: [
        'Virtual Gallery: A visually appealing digital display of traditional sculptures with high-quality images and detailed descriptions.',
        'Cultural Insights: Informative sections detailing the history and significance of each sculpture and its connection to South Indian culture.',
        "Customization Options: Users can request personalized sculptures or specific designs inspired by the temple's architecture.",
        'Online Purchase: A seamless e-commerce experience to purchase sculptures directly from artisans, promoting local craftsmanship.',
        'Mobile-Optimized Experience: A responsive design ensuring a smooth browsing experience across devices.',
      ],
      targetAudience: [
        'Art enthusiasts and collectors passionate about traditional Indian art.',
        'Travelers and tourists seeking souvenirs or mementos reflecting South Indian heritage.',
        'Academicians and students interested in learning about temple architecture and sculpture.',
        'Buyers looking for authentic handcrafted sculptures for decor or gifting purposes.',
      ],
    },
    website: 'https://mmsculptures.com',
  },
  {
    title: 'Excel Driving School - USA',
    image: excelDrivingImage,
    description: {
      Title: 'Excel Driving School - Arizona, USA',
      Description: 'Excel Driving School is a premier driver education institute in Arizona, dedicated to preparing confident, safe, and responsible drivers. With certified instructors, modern vehicles, and flexible programs, the school focuses on building strong driving skills and road safety awareness. This project aims to develop an engaging online platform that showcases training programs, instructor expertise, licensing guidance, and student success stories for learners of all ages.',
      KeyFeatures: [
        'Virtual Training Overview: Engaging visuals and descriptions of driving lessons, vehicles, and simulator-based learning.',
        'Course Insights: Clear breakdown of teen driver programs, adult lessons, and defensive driving courses.',
        'Instructor Profiles: Licensed trainers with expertise, teaching style, and availability details.',
        'Online Booking: Hassle-free scheduling of classes, packages, and DMV test prep through the website.',
        'Mobile-Optimized Experience: Learners can access lessons, resources, and booking tools easily on any device.',
      ],
      targetAudience: [
        'Teens preparing for their first driver’s license in Arizona.',
        'Adults seeking to learn driving from scratch or improve existing driving skills.',
        'Immigrants and newcomers to the U.S. needing to qualify for an Arizona driver’s license.',
        'Parents looking for trusted, safe, and certified driver education for their children.',
        'Community members and organizations interested in road safety awareness programs.',
      ],
    },
    website: 'https://exceldrivingschoolaz.com',
  },
  {
    title: 'Kissik Photography - USA',
    image: kissikPhotographyImage,
    description: {
      Title: 'Kissik Photography',
      Description: 'Kissik Photography is a professional photography brand specializing in capturing timeless moments with creativity and emotion. The project focuses on building a visually rich and user-friendly portfolio website that showcases photography services ranging from portraits to events, helping clients explore, book, and connect effortlessly.',
      KeyFeatures: [
        'Portfolio Gallery: High-quality image galleries categorized by events, portraits, weddings, and creative shoots.',
        'Responsive Design: Optimized viewing experience across desktops, tablets, and mobile devices.',
        'Online Booking & Inquiry: Easy contact and booking forms for clients to schedule photo sessions.',
        'Service Packages: Clear presentation of photography packages with pricing and inclusions.',
        'Fast Image Loading: Optimized performance for smooth browsing of high-resolution images.',
        'SEO Optimization: Enhanced visibility for photography-related searches and local reach.',
      ],
      targetAudience: [
        'Families looking for professional portrait and event photography.',
        'Couples seeking engagement, wedding, or pre-wedding photography.',
        'Small businesses and brands needing promotional or product photography.',
        'Individuals looking for creative photoshoots and personal branding.',
        'Clients searching for reliable photographers in the USA.',
      ],
    },
    website: 'https://kissikphotography.com',
  },
  {
    title: 'CoconutHill Grocery - USA',
    image: coconutHillImage,
    description: {
      Title: 'CoconutHill Grocery - Fremont, USA',
      Description: 'CoconutHill Grocery is a premier Indian and international grocery store in Fremont, USA, offering a wide selection of fresh produce, authentic spices, packaged foods, and specialty products. With a commitment to quality, affordability, and customer convenience, CoconutHill serves as the go-to destination for families and food enthusiasts looking for authentic flavors and everyday essentials. The website provides an engaging digital experience for browsing products, exploring deals, and staying connected with the store’s offerings.',
      KeyFeatures: [
        'Virtual Storefront: A digital showcase of grocery categories, fresh produce, spices, snacks, and daily essentials.',
        'Product Insights: Detailed information, pricing, and availability of items across multiple categories.',
        'Weekly Deals: Highlighted discounts, festive offers, and exclusive promotions updated regularly.',
        'Online Ordering: Seamless e-commerce experience with options for delivery or in-store pickup.',
        'Mobile-Optimized Experience: Smooth shopping and browsing on smartphones and tablets.',
      ],
      targetAudience: [
        'Families in Fremont and the Bay Area looking for authentic Indian groceries and international products.',
        'Students and professionals seeking affordable essentials and ready-to-eat options.',
        'Cooking enthusiasts searching for specialty ingredients, spices, and fresh produce.',
        'Community members who want convenient access to cultural and festive grocery needs.',
      ],
    },
  },
];

const Projects = () => {
  return (
    <div className="container py-3">
      <div className="banner-image">
        <img
          className="img-fluid rounded"
          alt="Projects"
          src={portfolioBanner}
        />
      </div>

      <div className="container py-3">
        <h2 className="fw-bold text-primary text-uppercase text-center">
          Our Projects
        </h2>
        <Portfolio projects={clients} />
      </div>
    </div>
  );
};

export default Projects;
